export const APP_ID = {
  CUSTOM_APP: 'CUSTOM_APP',
  MICROSOFT_365: 'MICROSOFT_365',
  MICROSOFT_365_OLD: 'MICROSOFT_365_OLD',
} as const;
